import {Injectable} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {ICruiseSpecialStamp} from '../interfaces/icruise-special-stamp';
import {catchError, map, shareReplay} from 'rxjs/operators';
import * as CruiseSpecialsStamps from '../../../../assets/data/cruisespecialsstamps.json';

@Injectable({
  providedIn: 'root'
})
export class CruiseSpecialsStampsService {

  constructor() { }

  formatSpecialStamp(specialStamp: any): ICruiseSpecialStamp {
    return {
      id: parseInt(specialStamp.id, 10),
      description: specialStamp.description,
      img: specialStamp.img,
      imgLabel: specialStamp.imgLabel,
      wtg: specialStamp.wtg,
      isEnabled: specialStamp.isEnabled
    };
  }

  getFormattedCruiseSpecialsStamps(): Observable<ICruiseSpecialStamp[]> {
    return this.getCruiseSpecialsStamps().pipe(
      map(e => e ? e.map((s: any) => this.formatSpecialStamp(s)) : undefined),
      map(specialsStamps => specialsStamps?.filter((specialStamp) => specialStamp.isEnabled) || []),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getCruiseSpecialsStamps(): Observable<any> {
    return of(CruiseSpecialsStamps).pipe(
      map((e: any) => e.default),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }
}
